/* eslint-disable import/no-anonymous-default-export */
export default {
  MIA_PAYMENT: 'Оплата MIA',
  commentForPicker: 'Комментарий для сборщика',
  howToUsePromocode: 'Как использовать промокод?',
  noPromos: 'У вас пока нет промокодов.',
  noOptions: 'Нет доступных опций',
  hide: 'Скрыть',
  notWorking: 'Не работает',
  chisinauDeliver: 'доставка в Кишиневе',
  categoryNotFound: 'В данный момент нет доступных ресторанов в этой категории !',
  categoryViewOpenedRestaurants: 'Посмотреть открытые рестораны',
  cookieConsentTextMob: '🍪 Мы используем cookies.',
  cookieConsentText: '🍪 Мы используем cookies для улучшения вашего опыта использования сайта.',
  okay: 'Хорошо',
  cartSurchargeDescription:
    'Мы работаем от комиссии с заказа. Если сумма чека низкая, это не покрывает расходов на доставку. Чтобы не вводить минимальную сумму заказа, мы взимаем небольшую доплату с клиентов, которые делают заказ на сумму меньше 200 лей. Любим тебя! 😍',
  smallOrder: 'Доплата за небольшой заказ',
  promoCodeRequired: 'Вы должны войти, чтобы использовать промокод',
  promoCode: 'Промокод',
  promoUsageLimit: 'Лимит использования',
  promoDetails: 'Детали',
  promoMinRequirement: 'Минимальная сумма',
  promoDiscount: 'Скидка',
  promoRestrictions: 'Ограничения',
  promoValidUntil: 'Действует до',
  promoCurrency: 'лей',
  selectRegion: ' зависит от района. Выберите район!',
  selectRegionDelivery: 'Цена на доставку',
  showMore: 'Показать еще',
  showLess: 'Показать меньше',
  loginRequired: 'Вы должны войти, чтобы оформить доставку',
  onlyCashPayment: 'Tолько наличными',
  viewMore: 'ещё',
  askForAddress: 'Вы уверены, что находитесь по данному адресу?',
  addAddressTitle: 'Укажите адрес доставки',
  addAddressDescription: 'Чтобы курьер смог вас найти',
  fewRatings: 'Мало отзывов',
  showMapInfo: 'Нет твоего адреса ?',
  showMap: 'Показать на карте',
  address: 'Адрес',
  courier_express: 'Посылка',
  markets: 'Магазины',
  restaurants: 'Рестораны',
  closeMaibModalDisclaimer:
    'Если вы закроете окно во время обработки платежа, это может привести к его неуспешному завершению.',
  payApplePayGpay: 'Оплата Apple/Google',
  paymentMethodTemporarilyDisabled: 'Временно недоступен',
  myPromocodes: 'Мои промокоды',
  each_n_free: 'Каждый {0} заказ - бесплатнaя доставка 🚚',
  each_n_free_disclaimer: '🎊 В новом месяце счёт начинается заново! Успей воспользоваться выгодой 🛍️',
  changeCard: 'Изменить карту',
  saveCard: 'Сохранить карту',
  dontSaveCard: 'Не сохранять карту',
  deleteCardInfo: `Вы уверены? Вы не можете отменить это действие.`,
  deleteCardTitle: 'Удалить карту',
  promoCodeCopied: 'Промокод успешно скопирован',

  payWithNewCard: 'Oплатить новой картой',
  all: 'Все',
  surchargeBadWeather: 'Надбавка за плохую погоду',
  orderDetailsCourierExpressStatus1: 'Ждем подтверждения заказа от оператора, обычно это занимает до 3 минут ⏳',
  orderDetailsCourierExpressStatus2: 'Курьер знает про твой заказ, и вскоре заберёт посылку 🥷',
  orderDetailsCourierExpressStep2: 'Скоро заберём',
  orderDetailsCourierExpressStatus3:
    'Курьеру выдали посылку, теперь осталось ждать не долго, пожелай ему добраться без пробок 🏎️',
  orderDetailsCourierExpressStep3: 'Посылка у курьера',
  orderDetailsCourierExpressStatus4:
    'Твой герой уже у дома, встречай его с улыбкой! Можно без цветов, и лучше с "чаем" 💶 😁',

  errorCourierExpressComment: 'Пожалуйста, добавьте комментарий к заказу',
  errorCreatingOrder: 'Упс! Ошибка при создании заказа',
  orderCreated: 'Заказ успешно создан',
  whereFrom: 'Откуда?',
  whereTo: 'Куда?',
  expressSender: 'Данные отправителя',
  expressSenderDescription: 'Подробная информация откуда мы забираем посылку',
  expressReceiver: 'Данные получателя',
  expressReceiverDescription: 'Подробная информация куда мы доставляем посылку',
  expressInfoDelivery: 'Информация о доставке',
  courierExpressPhotoUpload: 'Прикрепить фото',
  courierExpressCommnetHead: 'Опиши, что мы должны доставить',
  courierExpressCommnetDescription:
    'Расскажи максимально подробно, что мы должны доставить и, если можешь, добавь фотографию товара 🛍️',
  courierExpressDescription: 'Мы привезем что угодно из одной точки вашего города в другую.',
  courierExpress: 'Доставка посылок',
  expressChooseAddresses: 'Выберите адреса "Куда" и "Откуда"',
  notificationTitle: 'Разрешить уведомления, чтобы не пропустить скидки и акции.',
  welcomeTitle: 'Добро пожаловать!',
  welcomeMessage: 'Спасибо за подписку на наши уведомления.',

  order: 'Заказать',
  soon: 'Скоро',
  cartFreeDeliveryInfo: 'и получите бесплатную доставку первого заказа! 🎉',
  nameRequired: 'Пожалуйста, добавьте свое имя',
  invalidEmail: 'Неверный адрес электронной почты',
  tooHighNumber: 'Слишком большое число',
  validNumberWithoutDecimals: 'Пожалуйста, введите допустимое число без десятичных значений',
  phoneRequired: 'Требуется телефон',
  addressNotSelected: 'Адрес не выбран',
  appartament_office: 'Квартира/офис',
  SELECT_CARD: 'Выберите карту',
  CARD_REMOVED: 'Карта удалена',
  noCards: 'У вас нет добавленных карт.',
  myCards: 'Мои карты',
  addNewCard: 'Добавить новую карту',
  selectedCardDetails: 'Этой картой вы будете оплачивать заказы онлайн',
  accountBlockedTitle: 'Срочное уведомление об учетной записи: ваша учетная запись заблокирована',
  accountBlockedDescription: `Уважаемый {0},

С сожалением сообщаем Вам, что Ваша учетная запись на нашей платформе временно заблокирована из-за подозрительной активности и просрочки платежей.

Будьте уверены, что мы активно работаем над тем, чтобы решить эту проблему как можно быстрее. Нашим главным приоритетом является обеспечение безопасности и целостности вашей учетной записи и любых связанных с ней данных.

А пока, если у вас есть какие-либо срочные вопросы или проблемы, пожалуйста, не стесняйтесь обращаться в нашу службу поддержки. Мы ценим ваше понимание и сотрудничество в этом вопросе.

С уважением, команда STRAUS.`,
  yes: 'Да',
  no: 'Нет',
  nightSurcharge: 'Доплата за ночную доставку\n(с 00:00 до 06:00)',
  ADULTS_ONLY_CANCEL: `Нет, мне меньше`,
  ADULTS_ONLY_CONFIRM: `Да, продолжить`,
  СONTAINS_ADULTS_PRODUCTS: `Это товары для тех кому уже исполнилось 18 лет. Тебе точно можно?`,
  ATTACH_FILE: 'Прикрепить фото',
  DAILY_SPECIALS: 'Блюдо дня',
  CATEGORY: 'Категория',
  ENTER_PHONE_NUMBER: 'Введите номер телефона',
  PHONE_NUMBER_NOT_VALID: 'Некорректный номер телефона',
  SMS_WAS_SENT: 'SMS с кодом было отправлено на номер',
  SMS_CODE_NOT_RECEIVED: 'Не получили код?',
  BRAND_NEW: 'Новинка!',
  MY_DETAILS: 'Мои данные',
  MY_ADDRESSES: 'Мои адреса',
  FAVORITES: 'Избранное',
  SUPPORT: 'Поддержка',
  LOGOUT: 'Выйти',
  NEED_HELP: 'Возникли сложности? Мы всегда на связи',
  ADDED: 'Добавлено',
  ADD: 'Добавить',
  ADD_TO_CART: 'Добавить',
  CLEAR_TO_CART: 'Очистить',
  CLEAR_TO_CART_DESCRIPTION_PART1: 'У вас есть товары из ',
  CLEAR_TO_CART_DESCRIPTION_PART2: 'Корзину нужно освободить для нового заказа ',
  ADD_COMMENT: 'Добавь свой комментарий',
  DELETED: 'Товар удален',
  DELETE: 'Удалить',
  DELETE_ADDRESS: 'Удалить',
  SAVE_ADDRESS: 'Сохранить',
  SAVE: 'Сохранить',
  HELLO: 'HELLO',
  ARE_YOU_SHURE: 'Ты уверен?',
  LANG: 'Русский',
  LANGUAGE_SELECT_TITLE: 'Язык',
  ORDERS: 'Заказы',
  ORDER_EVALUATED: 'Оценить',
  NOT_FOUND: 'Эта страница не существует',
  NOT_FOUND_MARKET: 'Магазин не найден',
  NOT_FOUND_RESTAURANT: 'Ресторан не найден',
  NOT_FOUND_CATEGORY: 'Категория не найдена',
  NOT_FOUND_PROVIDER_SUBTITLE: 'Выберите другой ресторан или продукт',
  NOT_FOUND_SUBTITLE:
    'Точнее она существует, но только для того чтоб ты знал, что нужная вам страница...не существует! Извини!',
  SELECT_ADDRESS: 'Добавить адрес',
  ADD_NEW_ADDRESS: 'Добавить новый адрес',
  ADDRESS_REMOVE_SUCCESS: 'адрес был успешно удален',
  ADDRESS_REMOVE_ERROR: 'Ошибка удаления адреса',
  ADDRESS_CREATE_ERROR: 'Ошибка создания адреса',
  ADDRESS_UPDATE_ERROR: 'Ошибка обновления адреса',
  ADDRESS_SELECT_ERROR: 'Ошибка выбора адреса',
  SEARCH: 'Поиск',
  SEARCH_INPUT_FOR_RESTAURANTS: 'Поиск по ресторанам',
  SEARCH_IN: 'Поиск в',
  SEARCH_INPUT_FOR_MARKETS: 'Поиск по магазинам',
  SEARCH_NOT_FOUND: 'Результатов не найдено',
  SEARCH_RESULTS: 'Результаты поиска',
  CURRENCY: 'лей',
  RESTAURANTS_TITLE: 'Рестораны',
  MOBILE_SIDE_BAR_TITLE: 'Привет',
  RESTAURANT: 'Ресторан',
  MARKET: 'Магазин',
  RESTAURANTS_SUB_TITLE: 'Более 250 ресторанов',
  SHOPS_TITLE: 'Магазины',
  SHOPS_SUB_TITLE: 'Более 50 магазинов',
  SHOPS_FIND: 'Mагазины найдены',
  EXPRESS_COURIER: 'Заказать Курьера',
  EXPRESS_COURIER_SUB_TITLE: 'Доступно в приложении',
  COURIER_NAME: 'Курьер',
  CATEGORY_TITLE: 'Чего хочется сегодня?',
  RESTAURANT_CATEGORY: 'Категория ресторана',
  DOWNLOAD_THE_APPLICATION: 'Скачай приложение',
  DOWNLOAD_THE_APPLICATION_SUB_TITLE: 'С приложением оформлять заказы ещё легче, мы ценим твоё время!',
  INFORMATION: 'Информация',
  INFORMATION_SUB_TITLE_FOR_US: 'О нас',
  INFORMATION_SUB_TITLE_PARTNERS: 'Стать партнером Straus',
  INFORMATION_SUB_TITLE_CAREERS: 'Работа в Straus',
  GENERAL: 'Документы',
  GENERAL_TEAMS: 'Пользовательское соглашение',
  GENERAL_PROCESSING_PERSONAL_DATA: 'Обработка персональных данных',
  ERROR_UPDATE_DATA: 'Ошибка обновления данных',
  SUCCESS_UPDATE_DATA: 'Данные успешно обновлены',
  CONTACT: 'Контакты',
  FOLLOW_US_ON: 'Мы в соц. сетях ',
  VIEW_ALL: 'Посмотреть все',
  PROMOTION_TITLE: 'Скидки и акции',
  RECOMMENDED_RESTAURANTS: 'Рекомендуем',
  TOP_RESTAURANTS: 'Рекомендуем',
  NEW_RESTAURANTS_ON_STRAUS: 'Новинки недели',
  SORT_RECOMMENDED: 'Рекомендованные',
  SORT_ONLINE_PAYMENT: 'Онлайн оплата',
  SORT_BY: 'Сортировать',
  FILTER_TITLE: 'Фильтры',
  FILTERS_MORE: 'Больше фильтров',
  FILTER_RESET: 'Сбросить',
  RESTAURANTS_FIND: 'Рестораны найдены',
  FILTER_BY_CATEGORY: 'Чего хочется сегодня?',
  FILTER_BY_BENEFITS: 'Показать сначала',
  SOMETHING_WENT_WRONG: 'Что-то пошло не так',
  DETAILS: 'Детали',
  DETAILS_PROVIDER: 'Детали',
  DELIVERY_TIME: 'Время доставки',
  DELIVERY_TERMS: 'Условия доставки',
  DELIVERY_METHOD: 'Когда доставить?',
  DELIVERY_ZONE: 'Зона доставки',
  PAYMENT_METHOD: 'Способ оплаты',
  FAVOURITE: 'Избранное',
  FAVOURITE_ADD: 'Добавлено в избранное',
  ERROR_FAVOURITE_ADD: 'Ошибка при добавлении в избранное',
  FAVOURITE_REMOVE: 'Удалено из избранного',
  ERROR_FAVOURITE_REMOVE: 'Ошибка при удалении из избранного',
  FAVOURITE_IS_EMPTY: 'У тебя пока нет избранных',
  EMPTY_FAVORITES: 'Избранного пока нет',
  DELIVERY: 'Доставка',
  DELIVERY_FROM: 'Доставка от',
  MINUTES: 'мин',
  CLOSING_PROVIDER: 'Закроется в',
  WILL_OPEN_PROVIDER: 'Откроется',
  WILL_OPEN_TOMORROW_PROVIDER: 'Откроется завтра в',
  WILL_OPEN_TODAY_PROVIDER: 'Откроется сегодня в',
  TODAY: 'Сегодня в ',
  TOMORROW: 'Завтра в ',
  CLOSING_PROVIDER_DESCRIPTION:
    'в данный момент закрыт, у тебя есть возможность продолжить и оформить предварительный заказ или посмотреть другие открытые рестораны',
  PAUSE_PROVIDER_DESCRIPTION:
    'Прямо сейчас мы доставляем из ближайших ресторанов от тебя, а %providerName% находится далековато. Только не злись ❤️, выбери другой - ближайший ресторан.',
  PAUSE_PROVIDER_DESCRIPTION_PS:
    'П.С. По братски, может есть знакомые, кто хотел попробовать себя в роли курьера, посоветуй нас! Обняли 🤗',
  PAUSE: 'Пауза',
  PAUSE_UNTIL: 'Пауза до',
  OVERLOADED: 'Перегружен',
  OVERLOADED_TO: 'Перегружен до',
  AVAILABLE: 'Доступные',
  CONTINUE_HERE: 'Продолжить',
  OPEN_PROVIDER: 'Посмотреть открытые',
  OPEN_PROVIDER_IN: 'откроется в',
  PROVIDER_NO_REVIEWS: 'отзывов пока что не имеет',
  REVIEW: 'Отзывы',
  SUCCESS_SEND_REVIEW: 'Отзыв успешно отправлен, спасибо!',
  ERROR_SEND_REVIEW: 'Ошибка отправки отзыва!',
  PRODUCTS: 'Продукты',
  ADD_MORE_PRODUCTS: 'Закажи ещё на',
  SHOW_MORE_PROVIDERS: 'Показать еще',
  ADD_MORE_PRODUCTS_DESCRIPTION: 'и мы сделаем тебе скидку',
  ADD_MORE_PRODUCTS_DESCRIPTION_FREE: 'и доставка будет БЕСПЛАТНАЯ! 🆓',
  ORDERED_PRODUCTS: 'заказанные товары',
  ORDER_CREATE_ERROR: 'Ошибка создания заказа',
  MY_ORDERS: 'Мои заказы',
  DISCOUNT: 'Скидка',
  APPLY: 'Применить',
  FREE: 'Бесплатно',
  ADDRESSES_IN_CHISINAU: 'Адреса в Кишиневе:',
  WORK_PROGRAM_TODAY: 'График работы сегодня:',
  CHAT: 'Чат',
  SOUNDS: 'Звонок',
  YOUR_ORDER: 'Твой заказ',
  NEXT_STEP: 'Следующий шаг',
  CART: 'Корзина',
  CART_EMPTY: 'Корзина очищена',
  GO_TO_CART: 'Перейти в корзину',
  CUTLERY: 'Приборы',
  CUTLERY_DESCRIPTION: 'Спасибо, что без лишнего пластика! Одноразовые приборы бери, только если под рукой нет своих',
  COMPLETE_ORDER: 'Что-то ещё?',
  SPECIAL_MENTIONS: 'Комментарий',
  ADD_SPECIAL_MENTIONS: 'Можно добавить комментарий',
  ORDER_SUMMARY: 'Итого',
  ORDER_DELIVERED: 'Заказ доставлен',
  TOTAL_PRODUCTS: 'Товары',
  TOTAL_ORDER: 'К оплате',
  ORDER_COMPLETION: 'Завершение заказа',
  ORDER_DETAILS: 'Детали заказа',
  ORDER_STATUS_HERE: 'Детали заказа здесь',
  ORDER_CANCEL: 'Отменить заказ',
  ORDER_CANCEL_DESCRIPTION: 'Для отмены заказа пожалуйста укажи причину',
  ORDER_CANCELED: 'Этот заказ отменен',
  ORDER_SEND: 'Оформить заказ',
  ORDER_NUMBER: 'Номер заказа',
  ORDER_LOADING: 'Загрузка заказа',
  EVALUATE_ORDER: 'Оценить заказ',
  CHECKOUT: 'Проверка',
  PRE_ORDER_SUB_TITLE: 'нажав кнопку ты можешь оформить - предзаказ',
  PRE_ORDER_REQUIRED: 'Предзаказ обязателен',
  ADD_PRE_ORDER: 'Предзаказ',
  NO_PRE_ORDER: 'Предзаказ недоступен',
  SELECT_TIME_AND_DAY: 'Выбери время ',
  SELECT: 'Выбрать',
  SELECT_MAX_OPTIONS: 'Выбери максимум',
  SELECT_OPTIONS: 'Выбери опции',
  OPTIONS: 'опции',
  CANCEL: 'Отмена',
  DELIVERY_TO_ADDRESS: 'Доставка',
  DELIVERY_COST_INFO_TITLE: 'Сколько стоит доставка?',
  DELIVERY_COST_INFO_DESCRIPTION_PART1:
    'Стоимость доставки зависит от расстояния — чем меньше расстояние ' +
    'преодолевают наши курьеры, тем ниже стоимость доставки. ' +
    'Дополнительная доплата в размере 20 лей, возникает для адресов из ' +
    'удаленныйх районов.',
  DELIVERY_COST_INFO_DESCRIPTION_PART2:
    'При размещении заказа в одном из заведений, вы увидите общую' +
    'стоимость за доставку до его подтверждения. Базовая стоимость' +
    'доставки зависит от нашего соглашения с заведением, в котором вы' +
    'размещаете заказ, — чтобы узнать базовую стоимость доставки,' +
    'нажмите на иконку заведения, в верхней части страницы отображена' +
    'базовая стоимость доставки. Например: “Доставка от 39 лей”. Таким' +
    'образом, вы будете знать общую сумму к оплате до момента' +
    'подтверждения заказа.',
  PERSONAL_LIFT: 'Самовывоз (скоро...)',
  HOME: 'Дом',
  I_WORK_HERE: 'Доставить сюда',
  OFFICE: 'Офис',
  UNTITLED: 'Другой',
  ADDRESS_DETAILS: 'Адрес доставки',
  ADDRESS_APT_OFFICE: 'Номер: Кв/офис',
  INTER_PHONE: 'Домофон',
  USER_PHONE_NUMBER: 'Номер телефона',
  USER_PHONE_NUMBER_DESCRIPTION: 'Связь будем поддерживать по этому номеру телефона',
  STAIRS: 'Подъезд',
  FLOOR: 'Этаж',
  ADDRESS_PRIVATE_HOUSE: 'Частный дом',
  CHANGE_ADDRESS: 'Сохранить',
  FORCE_CHANGE_ADDRESS: 'Изменить адрес',
  ALERT_CHANGE_ADDRESS: 'Внимание! Ты собираетешься изменить адрес доставки.',
  ALERT_CHANGE_ADDRESS_MESSAGE: 'При изменении адреса доставки, корзина будет очищена. Удалить текущий адрес?',
  ONLINE_CARD_PAYMENT: 'Оплата картой на сайте',
  ONLINE_CARD_PAYMENT_MESSAGE: 'Оплата онлайн на странице банка, мы не сохраняем ваши данные',
  CASH_PAYMENT_ON: 'Оплата наличными',
  USER_NAME: 'Имя',
  USER_NAME_PLACEHOLDER: 'Твое имя',
  USER_AGREEMENT: 'Пользовательское соглашение',
  USER_NAME_AND_SURNAME: 'Имя',
  USER_NAME_DESCRIPTION: 'Можно и никнейм',
  EMAIL_PLACEHOLDER: 'Электронная почта',
  EMAIL_DESCRIPTION: 'На эту почту мы отправляем чеки и письма, надеюсь, у тебя есть к ней доступ',
  ADD_VOUCHER: 'Добавить промокод',
  ADD_VOUCHER_PLACEHOLDER: 'Введи промокод',
  VOUCHER_TITLE: 'У тебя есть промокод?',
  VOUCHER: 'Промокод',
  VOUCHER_DESCRIPTION: 'Введи новый промокод',
  ORDER_STATUS_AUTO_CONFIRMED: 'Заказ автоматически подтвержден',
  ORDER_STATUS_4: 'Курьер у дома, ожидай его',
  ORDER_STATUS_DELIVERED: 'Заказ доставлен',
  YOU_HAVE_NO_ORDERS: 'У тебя нет заказов',
  DURATION_ORDER_TITLE: 'Заказ доставим примерно в',
  HELP: 'Помощь',
  LOGIN_TITLE: 'Войти',
  CLEAR_CART_TITLE: 'Ты действительно хочешь очистить корзину?',
  CLEAR: 'Очистить',
  CLEAR_CART_DESCRIPTION: 'Корзину нужно освободить для нового заказа',
  ADDING_PRODUCT_FROM_ANOTHER_RESTAURANT_TITLE: 'Очистить корзину?',
  LEAVE_PRODUCTS: 'Стоп',
  RESTAURANT_NEARBY: 'Рестораны рядом',
  PREORDER: 'Предзаказ',
  COMPLETE_ALL_FIELDS: 'заполните все поля',
  FIELD_IS_REQUIRED: 'Поле обязательное',
  IS_REQUIRED: 'Обязательно',
  THIS_FIELD_IS_TOO_LONG: 'Это поле не может быть таким длинным',
  GO_TO_MAIN_PAGE: 'На главную страницу',
  TO_PLAN: 'Планировать на',
  PAY_ORDER: 'Оплатить заказ',
  ORDER_IS_PAID: 'Этот заказ оплачен',
  ORDER_FOR_SELF_TITLE: 'Заказываю для себя',
  ERROR_ORDER_IS_PAID: 'Ошибка оплаты этого заказа',
  RECOMMENDED_PRODUCT: 'Рекомендуем',
  RECIPIENT_DATA: 'Данные получателя',
  POLICY_PART_1: 'Я прочитал и согласен с',
  POLICY_PART_2: 'Пользовательским соглашением',
  POLICY_PART_3: 'и даю согласие на обработку моей личной информации',
  BASE_DELIVERY_TIME: 'Доставка в среднем за 50 минут',
  DELIVERY_DETAILS_DESCRIPTION:
    'Стоимость и среднее время доставки можно найти на странице интересующего тебя ресторана. ' +
    'Время доставки будет сокращено в случае если твой адрес доставки находится в одном районе с адресом ресторана. ' +
    'Мы доставляем заказы в пределах указанной зоны на карте. Если твой адрес находится за пределами указанной зоны, ' +
    'Уточняй стоимость, время и возможность доставки в данный момент у наших операторов. ' +
    'Задавай интересующие тебя вопросы в чате или позвони по телефону 0(22)899-999',
  ABOUT_US_TITLE: 'Чем мы занимаемся',
  ABOUT_US_DESCRIPTION:
    'Straus - это лучший сервис по заказу и доставке еды! ' +
    'Ты получаешь доступ к меню десятков ресторанов, ' +
    'а также можешь ознакомиться с их рейтингом и специальными предложениями. ' +
    'Мы ценим твое время, поэтому хотим предоставить возможность легко и просто оформить заказ, ' +
    'а наша команда за максимально короткое время доставит его на дом, в офис или в любую точку города. ' +
    'В списке нашего меню 216 рестораны, кафе, пиццерии, суши-бары и пабы. ' +
    'С командой STRAUS.md - ты никогда не останешься голодным!',
  CONTACT_US: 'Свяжись с нами',
  ADDRESS_OFFICE: 'Кишинев, Театральная 15B',
  YOUR_CART_IS_EMPTY: 'Ваша корзина пустая',
  CLOSE_PROVIDER: 'Закрыто',
  TEMP_CLOSE_PROVIDER: 'Временно закрыто',
  TODAY_IN: 'cегодня в ',
  TOMORROW_IN: 'Завтра в ',
  SCHEDULE_FOR: 'запланировать на ',
  EVALUATE_ORDER_RATE_FORM_TITLE: 'Какими были продукты от ',
  EVALUATE_COURIER_RATE_FORM_TITLE: 'Как вам доставка, сделанная ',
  ORDER_STATUS_1_NEW_ORDER_FOR_RESTAURANT: 'Ждём подтверждение заказа от ресторана, обычно это занимает до 3 минут ⏳',
  ORDER_STATUS_1_NEW_ORDER_FOR_MARKET: 'Ждём подтверждение заказа от магазина, обычно это занимает до 3 минут ⏳',
  ORDER_STATUS_2_FOR_RESTAURANT:
    'Ресторан подтвердил заказ и начал готовить твои вкусняшки 🧑‍🍳, если это конечно не предзаказ. ',
  ORDER_STATUS_2_FOR_MARKET: 'Магазин подтвердил заказ и начал его собирать 🛍️, если это конечно не предзаказ. ',
  ORDER_STATUS_3_RESTAURANT: 'Курьер уже в ресторане, ожидает выдачу заказа  🥷',
  ORDER_STATUS_3_MARKET: 'Курьер уже в магазине, ожидает выдачу  заказа 🥷',
  COURIER_RIDES: 'Курьеру выдали заказ, теперь осталось ждать недолго, пожелай ему добраться без пробок 🏎️',
  COURIER_SLOGAN: 'Я приеду к Вам как можно скорее',
  COURIER_NUMBER_PHONE: 'Номер курьера',
  CALL_US: 'Дайте нам знать, если у вас возникнут проблемы с доставкой',
  RECIPIENT_DATA_REQUIRED: 'Данные получателя обязательны',
  POLICY_PART_4: 'Политики конфедециальности',
  PLEASE_CHECK_POLICY: 'Cогласие с политикой обязательно',
  RESTAURANT_DELIVERING:
    'Ресторан подтвердил заказ и начал готовить ваши деликатесы 🧑‍🍳, если это точно не предзаказ. Приятного аппетита и не забудьте оценить заказ! ⚠️ Заказ доставит курьер ресторана, здесь вы не сможете отследить статус заказа. Если у вас есть вопросы по заказу, звоните, поможем!',
  NO_RESULTS_SEARCH_ADDRESS: 'Нет результатов поиска',
  SEARCH_ADDRESS_PLACEHOLDER: 'Улица и номер дома',
  YOU_HAVE_18_YEARS: 'Вам уже есть 18 лет',
  NOT_FAVOURITES: 'У вас нет избранных',
  ACTIVE_ORDERS: 'Активные заказы',
  MY_DATA: 'Мои данные',
  FOR_ADULT: '18+',
  BANNER_REDIRECT_ON_MOBILE_APP_TITLE: 'У Straus есть крутое мобильное приложение',
  DOWNLOAD_MOBILE_APP: 'Скачать мобильное приложение',
  STOP_RUN_SITE:
    'Привет, друг! Проводятся технические работы на сайте , просим тебя оформить заказ в мобильном приложении  Straus. Извини за неудобство.',
  PRESENTATION_IMAGE_WARNING: 'Продукты на изображении предназначены для презентации',
  WEIGHTED: 'Весовой продукт',
  NON_STOP: 'Круглосуточно',
  LIKE: 'Да мне понравилось!',
  DISLIKE: 'Мне не понравилось!',
  WHAT_CAN_IMPROVE: 'Что можно улучшить?',
  FAR_AREA_SURCHARGE: 'Доплата за дальний район',
  LOCATION_OUTSIDE_DELIVERY: 'Адрес вне доставляемой зоны',
  LOCATION_SEARCH_ERROR: 'Ошибка при поиске адреса. Попробуйте снова',
  GEOLOCATION_NOT_SUPPORTED: 'Геолокация не поддерживается',
  REQUIRE_GEOLOCATION_PERMISSIONS: 'Требуется разрешение на использование геолокации',
  INGREDIENTS: 'Состав',
  STORAGE_INSTRUCTIONS: 'Условия хранения',
  BRAND: 'Бренд',
  COUNTRY_OF_ORIGIN: 'Производитель',
  WILL_BE_USEFUL: 'Что ещё пригодится',
  FREE_DELIVERY_PROMO_CONFLICT_TITLE: 'Промокод отменит бесплатную доставку',
  FREE_DELIVERY_PROMO_CONFLICT_TEXT: 'Если вы примените промокод, бесплатная доставка не применится.',
  //Metro
  MAIN: 'Главная',
  PRICE: 'Цена',
  DEFAULT: 'По умолчанию',
  CHEAP: 'Дешевые',
  EXPENSIVE: 'Дорогие',
  CONTINUE: 'Продолжить',
  FILTERS: 'Фильтры',
  TRADEMARK: 'Торговая марка',
  COUNTRY: 'Страна',
  PURPOSE: 'Назначение',
  AMOUNT: 'Количество',
  PROFITABLE_SHELF: 'Скидки и акции',
  PRODUCT_CATEGORIES: 'Категории продуктов',
  NOT_AVAILABLE: 'Нет в наличии',
  CATEGORIES: 'Категории',
  PCS: 'шт',
  KG: 'кг',
  ALPHABETICALLY_A_Z: 'По алфавиту от A до Я',
  ALPHABETICALLY_Z_A: 'По алфавиту от Я до А',
  IS_NEW: 'Новинки',
  ONLY_IN_STOCK: 'Только в наличии',
  BACK: 'Назад',
  CLEAR_FILTERS: 'Очистить фильтры',
  CLOSE: 'Закрыть',
  PROMOTIONAL_ITEMS: 'Акционные товары',
  SHOW_ALL: 'Показать все',
  FAVORITE_PRODUCTS: 'Избранные товары',
};
